import { useForm } from "react-hook-form";

import { useAppSelector } from "store/store";
import { GenericLandingCard, ResetPasswordForm } from "../components";
import {
  GenericBackToBtn,
  SendEmailResetPasswordBtn,
} from "components/buttons";

export const ResetPasswordPage = () => {
  const resetPasswordForm = useAppSelector(
    (state) => state.resetPasswordFormSlice.value
  );
  const { control, handleSubmit, trigger } = useForm({
    mode: "onChange",
    defaultValues: resetPasswordForm,
  });
  return (
    <GenericLandingCard
      rightColumn={
        <ResetPasswordForm
          control={control}
          handleSubmit={handleSubmit}
          trigger={trigger}
        />
      }
      rightInteraction={<SendEmailResetPasswordBtn />}
      leftInteraction={<GenericBackToBtn label="Indietro" link="/" />}
    ></GenericLandingCard>
  );
};
